export const SUPPORTED_DELIVERY_CITIES = [
  { name: 'Berlin', normalized: 'berlin', lat: 52.52, lng: 13.405 },
  { name: 'Hamburg', normalized: 'hamburg', lat: 53.5511, lng: 9.9937 },
  { name: 'München', normalized: 'muenchen', lat: 48.1351, lng: 11.582 },
  { name: 'Köln', normalized: 'koeln', lat: 50.9375, lng: 6.9603 },
  { name: 'Frankfurt am Main', normalized: 'frankfurt-am-main', lat: 50.1109, lng: 8.6821 },
  { name: 'Stuttgart', normalized: 'stuttgart', lat: 48.7758, lng: 9.1829 },
  { name: 'Düsseldorf', normalized: 'duesseldorf', lat: 51.2277, lng: 6.7735 },
  { name: 'Leipzig', normalized: 'leipzig', lat: 51.3397, lng: 12.3731 },
  { name: 'Dortmund', normalized: 'dortmund', lat: 51.5136, lng: 7.4653 },
  { name: 'Essen', normalized: 'essen', lat: 51.4556, lng: 7.0116 },
  { name: 'Bremen', normalized: 'bremen', lat: 53.0793, lng: 8.8017 },
  { name: 'Dresden', normalized: 'dresden', lat: 51.0504, lng: 13.7373 },
];

export const DEFAULT_DELIVERY_CITY = 'dresden';
